import { arrayOf, Schema } from 'normalizr';
import { transformUtil } from 'js-utils/transformation';

const SERIES_EVENT_SCHEMA = new Schema('seriesEvents');

const SERIES_EVENTS_SCHEMA = {
    events: arrayOf(SERIES_EVENT_SCHEMA),
};

const SERIES_EVENT_RESPONSE_FIELDS = [
    'id',
    'name',
    'text',
    'start',
    'end',
    'local',
    'timezone',
    'hide_end_date',
    'currency',
    'status',
    // series parent id
    'series_id',
    'ticket_availability',
    'has_available_tickets',
    'is_sold_out',
    'waitlist_available',
    // ticket price
    'minimum_ticket_price',
    'value',
    // venue
    'venue',
    'address',
    'localized_area_display',
];

export const transformSeriesEventsData = (data) => {
    const transformedSeriesEvents = transformUtil({
        response: data,
        schema: SERIES_EVENTS_SCHEMA,
        fields: SERIES_EVENT_RESPONSE_FIELDS,
        isWhiteList: true,
    });

    return {
        seriesEvents: transformedSeriesEvents.entities.seriesEvents,
    };
};

export const transformSeriesPaginationData = (data) => ({
    continuationToken: data.pagination.continuation,
    hasMoreItems: data.pagination['has_more_items'],
});
